<template>
  <div>
    <v-card-title
      class="h3 font-weight-bold px-4 mb-0 d-flex justify-space-between align-center"
      style="background-color: #fec627; position: sticky; top: 0; margin-top: 0; z-index: 999"
    >
      <span>Successfully unenrolled</span>
      <v-icon @click="closeDialog()" color="black" class="cursor-pointer">mdi-close</v-icon>
    </v-card-title>
    <v-container class="container">
      <v-row wrap class="unenroll-grid">
        <v-col cols="12">
          <div class="text-body-2">You have successfully unenrolled from the course.</div>
        </v-col>
        <v-form ref="form" v-model="valid" @submit.prevent="formIsValid && patchEnrollmentAndCreatedFeedbackRecord()">
          <v-col cols="12">
            <strong class="text-body-2 font-weight-bold"
              >If you have a moment, please let us know why you unenrolled:</strong
            >

            <v-radio-group v-model="unenrollReason" class="unenroll-reasons">
              <v-radio
                v-for="reason in expectedUnenrollReason"
                :key="reason"
                :label="reason"
                :value="reason"
                color="black"
              />
            </v-radio-group>
            <v-text-field
              v-if="checkOtherReason"
              v-model.trim="otherReason"
              :rules="[
                (v) => (!!v && v.length < 250) || 'This is required and length should be less than 250 characters'
              ]"
              variant="outlined"
            />
          </v-col>
          <v-col cols="12">
            <strong class="text-body-2 font-weight-bold">Is there anything else you’d like us to know?</strong>
          </v-col>
          <v-col cols="12">
            <v-textarea name="input-7-1" variant="outlined" label="Your answer" auto-grow v-model="unenrollFeedback" />
          </v-col>
          <v-col cols="12">
            <v-btn
              variant="flat"
              rounded
              style="
                background: #fec528 !important;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 48px;
              "
              color="#000000"
              class="px-4 ml-0"
              :disabled="!formIsValid"
              @click="patchEnrollmentAndCreatedFeedbackRecord()"
            >
              <span class="font-weight-black" style="font-size: 18px">Share feedback</span>
            </v-btn>
          </v-col>
        </v-form>

        <v-col cols="12">
          <button type="button" class="text-body-2 close-message" @click="closeDialog">Or close this message</button>
        </v-col>
      </v-row>
      <!-- Keeping this unused code in case of later requirement changes -->
      <v-row wrap class="d-none">
        <v-col cols="12" v-if="!isRefundEligibleCached">
          <strong class="subheading">You have successfully unenrolled from the course.</strong>
        </v-col>
        <v-col cols="12" class="mt-3" v-else-if="isRefundEligibleCached">
          <strong class="subheading">
            You have unenrolled from the course before the drop deadline according to ULC Terms of Use.
            <a
              href="https://ulc.asu.edu/terms-of-use/"
              class="font-weight-bold"
              style="color: black; border-bottom: 2px solid #ffc627"
              target="_blank"
              rel="noopener"
            >
              ULC Terms of Use.
            </a>
          </strong>
        </v-col>
        <v-col cols="12" class="mt-4" v-if="isRefundEligibleCached">
          <strong class="subheading">
            Please allow 3-5 business days to see your refund reflected on your account.
          </strong>
        </v-col>
        <v-col cols="12" class="">
          <v-btn
            variant="outlined"
            rounded
            style="border: 2px solid; background: white !important; padding-top: 12px; padding-bottom: 12px"
            dark
            color="#000000"
            class="pa-4 mx-0 mt-5"
            @click="switchToFeedback"
          >
            <span class="font-weight-black" style="font-size: 18px"> Close this message </span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { Logger } from '../mixins/logger';
import { Helper } from '../mixins/helpers';

export default defineComponent({
  emits: ['closeDialog', 'isSuccessfulUnenroll'],
  name: 'PostUnenrollment',

  data() {
    return {
      valid: true,
      otherReason: '',
      unenrollFeedback: '',
      unenrollReason: '',
      expectedUnenrollReason: [
        'I want to choose a different course',
        'Personal Reasons',
        'I experienced access or technical difficulties',
        'Other'
      ],
      isEMVerifiedCached: null,
      isRefundEligibleCached: null,
      showFeedback: false
    };
  },

  mixins: [Helper, Logger],

  props: {
    enrollmentId: String,
    isEMVerified: Boolean,
    isRefundEligible: Boolean
  },

  computed: {
    checkOtherReason() {
      return this.unenrollReason.toLowerCase() === 'other';
    },
    formIsValid() {
      return this.unenrollReason && (this.checkOtherReason ? this.otherReason : true);
    }
  },

  methods: {
    isShowFeedback() {
      return !this.isEMVerifiedCached && !this.isRefundEligibleCached;
    },

    switchToFeedback() {
      this.showFeedback = true;
    },

    closeDialog() {
      this.$emit('closeDialog');
      this.$emit('isSuccessfulUnenroll');
    },

    async patchEnrollmentAndCreatedFeedbackRecord() {
      try {
        this.$conn.patchLearnersInfo({
          unenrollReason: this.checkOtherReason ? this.otherReason : this.unenrollReason,
          unenrollFeedback: this.unenrollFeedback,
          enrollmentId: this.enrollmentId
        });
        this.logInfo('patchEnrollmentAndCreatedFeedbackRecord patched info');
        this.closeDialog();
      } catch (error) {
        // eslint-disable-next-line no-console
        this.logError('patchEnrollmentAndCreatedFeedbackRecord ', error);
      }
    }
  },

  created() {
    this.isEMVerifiedCached = this.isEMVerified;
    this.isRefundEligibleCached = this.isRefundEligible;
    this.showFeedback = this.isShowFeedback();
  }
});
</script>

<style scoped>
.unenroll-grid {
  margin: -12px !important;
}

.unenroll-grid .v-col {
  padding: 12px !important;
}

.close-message {
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  text-decoration: underline;
  color: #747474;
  cursor: pointer;
}

.unenroll-reasons :deep(.v-selection-control__input) {
  justify-content: center !important;
}

.unenroll-reasons :deep(.v-label) {
  color: rgba(0, 0, 0, 0.87) !important;
  opacity: 1;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: normal;
}
</style>
